import actions from "./actions";

const {
    FETCH_CHANGED_PERMISSIONS,
} = actions;

const initState = {
    changedPermissions: [],
    pagination: {}
};

const ChangedPermissionReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_CHANGED_PERMISSIONS:
            return {
                ...state,
                changedPermissions: data?.logs || [],
                pagination: data?.pagination || {}
            };

        default:
            return state;
    }
};

export default ChangedPermissionReducer;